// Which answers this build uses. The import below is pointed at web.ts or native.ts by the
// build itself (see vite.config.ts), so the bundle a browser downloads carries no Capacitor
// and the one a shell ships carries no dead web paths. `web.ts` is the reference.
import type { Platform } from '../platform.js';
import { impl } from '#platform-impl';

export const platform: Platform = impl;
